export default require('../../client/marriage/QuestionsPage').default;
